import { fetchAPI } from "@/utils/fetchAPI";

export type ProductName =
  | "Forfait avec Engagement"
  | "Gestion+ avec Engagement"
  | "Saisie PREMIER"
  | "Gestion+"
  | "eCofiCoffre";

type FetchCofidocBillingsParams = {
  username?: string | null;
  email?: string | null;
};

export async function fetchCofidocBillings({ username, email }: FetchCofidocBillingsParams = {}) {
  try {
    const queryParams = new URLSearchParams();
    if (username) queryParams.append("username", username);
    if (email) queryParams.append("email", email);

    const queryString = queryParams.toString();
    const url = `/account/bills${queryString ? `?${queryString}` : ""}`;

    const res = await fetchAPI({
      url,
      options: {
        method: "GET",
      },
    });

    return res.map((c) => ({ ...c, date: new Date(c.date) }));
  } catch (error) {
    throw new Error();
  }
}
